import React from 'react';
import ClearingMemberAccountsContainer from '../../ClearingMemberAccounts/ClearingMemberAccountsContainer';
import LedgerAccountsGrid, { LEDGER_ACCOUNTS_GRID_NAME } from 'components/agGrid/ClearingAccounts/LedgerAccounts/LedgerAccountsGrid';

const AddLedgerAccountContainer = ({
  accounts,
  personalValues,
  addLedgerAccounts,
  removeLedgerAccounts,
}) => (
  <div className="xwizard-form-group">
    <ClearingMemberAccountsContainer
      userAccounts={accounts}
      wizardView
      addLedgerAccounts={addLedgerAccounts}
      removeLedgerAccounts={removeLedgerAccounts}
      personalValues={personalValues}
      gridOpts={{
        gridName: LEDGER_ACCOUNTS_GRID_NAME,
        GridComponent: LedgerAccountsGrid,
      }}
    />
  </div>
);

export default AddLedgerAccountContainer;
